import {
  coverageStatusOf,
  coverageTitle,
  TagCoverage,
  TagCoverageStatus,
} from 'features/sentinels/coverage'
import React from 'react'
import styled from 'styled-components'

const DOT_COLOR: Record<TagCoverageStatus, string> = {
  active: 'var(--chart-2)',
  experimenting: 'var(--primary)',
  none: 'var(--border)',
}

const Dot = styled.span<{ $status: TagCoverageStatus }>`
  display: inline-block;
  width: 6px;
  height: 6px;
  flex-shrink: 0;
  border-radius: 9999px;
  background: ${({ $status }) => DOT_COLOR[$status]};
`

export const CoverageDot: React.FC<{ coverage: TagCoverage | undefined }> = ({
  coverage,
}) => (
  <Dot
    aria-hidden
    $status={coverageStatusOf(coverage)}
    title={coverageTitle(coverage)}
  />
)
